import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

import { BaseComponent } from '../../base/components/base-component';
import { __ } from '../../functions/object.functions';

@Component({
    selector: 'intello-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchComponent extends BaseComponent implements OnInit {

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC INSTANCE VARIABLES
  // -----------------------------------------------------------------------------------------------------

  form: UntypedFormGroup;

  // -----------------------------------------------------------------------------------------------------
  // @ VIEW CHILD/CHILDREN VARIABLES
  // -----------------------------------------------------------------------------------------------------

  @ViewChild('search', { static: true }) searchElement: ElementRef;

  // -----------------------------------------------------------------------------------------------------
  // @ INPUT VARIABLES
  // -----------------------------------------------------------------------------------------------------

  @Input() width: string = '320px';

  @Input() placeholder: string = 'General.Search for';

  @Output() onValueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() isLoading: boolean = false;

  @Input() debounceTime: number = 300;

  @Input() autofocus: boolean = false;

  @Input() emitOnEnter: boolean = true;

  private _value: string = '';

  @Input()
  public get value(): string {
    return this._value;
  }

  public set value(value: string) {
    if (value !== this.value) {
      this._value = value;

      if (!this.IsNullOrUndefinedOrEmpty(this.form)) {
        this.form.get('search').setValue(value);
      }
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ CONSTRUCTOR
  // -----------------------------------------------------------------------------------------------------

  constructor(
    private fb: UntypedFormBuilder
  ) {
    super();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ LIFE CYCLE HOOKS
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {

    this.form = this.fb.group({
      search: this.value
    });

    super.addSubscription(this.form.get('search').valueChanges.pipe(
      debounceTime(this.debounceTime)
    ).subscribe((search: string) => {
      if (this.emitOnEnter === false) {
        this.onValueChange.emit(search);
      }
    }));

    if (this.autofocus && !__.IsNullOrUndefined(this.searchElement)) {
      setTimeout(() => {
        // according to https://stackoverflow.com/questions/50006888/angular-5-set-focus-on-input-element
        // we should use timeout here and then set the focus of our input
        this.searchElement.nativeElement.focus();
      }, 300);
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC METHODS
  // -----------------------------------------------------------------------------------------------------

  emitValue(): void {
    this.onValueChange.emit(this.form.get('search').value);
  }
}
